import React from 'react';
import PropTypes from 'prop-types';
import { Container, Inner, ImageProject, Highlight } from './styles';

import { FaInfoCircle } from 'react-icons/fa';
import parse from 'html-react-parser';

// import ModalProject from '~/components/ModalProjetos';
export default function Section03SliderItem({
  image,
  title,
  subtitle,
  text,
  toSupport,
  // link,
  clickFunction,
}) {
  function linkClick(e) {
    e.preventDefault();
    return clickFunction;
  }
  return (
    <>
      <Container>
        <Inner onClick={clickFunction}>
          <h1>{title}</h1>
          <h2>{subtitle}</h2>
          {/* <HighlightContainer>
            <p>Público alvo principal:</p>
            <Highlight>{parse(toSupport)}</Highlight>
          </HighlightContainer> */}
          <Highlight>
            <b>
              <FaInfoCircle size={22} />
              Para apoiar este projeto, anote:
            </b>
            <ul>{parse(toSupport)}</ul>
          </Highlight>
          <p>{text}</p>
          <ImageProject>
            <img src={image} alt={title} />
          </ImageProject>
          <button onClick={e => linkClick(e)}>
            CONHEÇA MAIS SOBRE ESSE PROJETO
          </button>
        </Inner>
      </Container>
    </>
  );
}

Section03SliderItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string,
  toSupport: PropTypes.string,
  clickFunction: PropTypes.func,
};
